export const EventType = Object.freeze({
    AjaxPostEvent: 'ajaxPostEvent',
    OnClickDownloadEvent: 'onClickDownloadEvent',

    OnInputChange: 'onInputChange',
    OnInputBlur: 'onInputBlur'
});
